import { render } from "./MatchCell.vue?vue&type=template&id=69403a07&scoped=true&ts=true"
import script from "./MatchCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchCell.vue?vue&type=script&setup=true&lang=ts"

import "./MatchCell.vue?vue&type=style&index=0&id=69403a07&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69403a07"],['__file',"src/components/home/MatchCell.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69403a07"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69403a07', __exports__)) {
    console.log('reload')
    api.reload('69403a07', __exports__)
  }
  
  module.hot.accept("./MatchCell.vue?vue&type=template&id=69403a07&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('69403a07', render)
  })

}


export default __exports__